module.exports = __webpack_public_path__ + "spain.svg?38c951335c8f27fd1e11250a20d1e23f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/spain.svg
// module id = 141
// module chunks = 0